export type TourPoiSelectionRequest = {
    tourContextKey: string;
    poiId: string | null;
    origin: "gps" | "tray" | "map" | "page";
};

export type TourPoiSelectionSnapshot = TourPoiSelectionRequest & { revision: number };
export const tourPoiSelectionChangedEventName = "smartguide:tour-poi-selection-changed";
